import { ErrorHandler } from '@angular/core';
import { environment } from 'src/environments/environment';

// Create a new ErrorHandler and report an issue straight to Raygun
export class RaygunErrorHandler implements ErrorHandler {
  handleError(e: any): void {
    if (window.location.hostname === environment.config.site_uri) {
      try {
        // Use window.rg4js instead of require() to avoid bundling issues
        if (typeof window !== 'undefined' && (window as any).rg4js) {
          (window as any).rg4js('send', { error: e });
        } else {
          console.warn('Raygun not available, falling back to console error');
        }
      } catch (raygunError) {
        console.error('Raygun error reporting failed:', raygunError);
      }
    }
    console.error(e);
  }
}
